import React from 'react';
import './button.scss';

export const Button = props => {

  const { id, primary, secondary, warning, onClick, floatRight, sm, icon, style, setTextBoxHeight, append,
    disabled, appendToTextBox, className, lightGray } = props;
  const classNames = primary ? 'new-btn-primary' : secondary ? 'new-btn-secondary' : warning ? 'new-btn-warning' : lightGray ? 'new-btn-light-gray' : '' ;
  const allClasses = `${!append ? 'new-btn ' : 'btn-inside '} 
  ${classNames}${floatRight ? ' float-right' : ''}${sm ? ' new-btn-sm' : ''}${setTextBoxHeight ? ' text-box-height' : ''}${appendToTextBox ? ' btn-append-with-text-box' : ''} ${className !== '' && className !== undefined ? ` ${className}` : ''}`;

  var button = <button
    id={id}
    className={allClasses}
    onClick={onClick}
    style={style}
    type='button'
    disabled={disabled === true ? "disabled" : ""}
  > {props.children}
    {icon && !append ? <i className={`${icon}`} style={{ fontSize: 18 }} /> : null}
  </button>;

  if (append) {
    return <div className="input-group">
      <div className='btn-full'>
        {button}
        <div className="input-group-append">
          <div className="input-group-text append">
            <i className={`${icon}`} />
          </div>
        </div>
      </div>
    </div>
  }

  return button;
};